import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraWorkplaceWellbeingSpotIllustration: FunctionComponent<Props> = ({ size = 96 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M32.225 0.239258C27.8073 0.239258 23.5212 0.996819 19.4855 2.49044C9.87754 6.05186 3.12272 13.9474 0.952482 24.1524C-0.481698 30.806 -0.298315 36.9601 1.51654 42.9574C3.83349 50.6164 9.52089 57.0753 17.1205 60.6772C20.8932 62.4693 25.2273 63.4925 30.0003 63.7176C30.6137 63.7454 31.2372 63.7606 31.8569 63.7606C35.6865 63.7606 39.5388 63.2357 43.3076 62.2012C43.5972 62.1291 43.8729 62.0545 44.1638 61.9685C47.5507 60.9769 50.5987 59.4087 53.2065 57.3131C56.0382 55.0505 58.369 52.1822 60.127 48.7927C60.4735 48.125 60.8049 47.4218 61.1704 46.5808C63.1812 41.9114 64.1525 36.6844 63.9805 31.4586C63.8996 29.148 63.5556 26.6919 62.9612 24.1524C61.9823 20.032 60.3862 16.1569 58.345 12.9395C57.786 12.0757 57.2725 11.3497 56.7641 10.6971C53.0952 5.9646 47.3787 2.64347 40.2382 1.098C37.6151 0.528876 34.9188 0.240522 32.2262 0.240522L32.225 0.239258Z'
        fill='white'
        fillOpacity='0.4'
      />
      <Path
        d='M22.3544 24.0306C22.3544 24.0306 16.1132 23.3506 14.4744 25.3693C12.2594 28.0993 12.7744 31.5543 14.4744 33.3543C16.1744 35.1543 20.1907 39.2231 23.5894 39.0681C26.9882 38.9131 23.5894 34.9993 23.5894 34.9993C23.5894 34.9993 21.7869 35.0506 20.3444 34.2781C18.9019 33.5056 15.1944 30.9306 15.7094 28.6643C16.2244 26.3981 19.5719 25.9343 22.1982 28.9218C24.8244 31.9093 22.3532 24.0293 22.3532 24.0293L22.3544 24.0306Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M22.4471 17.993C22.4471 17.993 19.8459 18.6717 20.4959 22.273C21.1459 25.873 21.8459 42.7642 24.0559 45.4905C26.2659 48.2167 32.6521 47.6067 34.0021 47.6067C35.3521 47.6067 41.8609 47.5355 43.0896 45.263C44.1321 43.3342 46.5009 27.1267 46.8934 21.7292C46.9734 20.6367 45.9721 18.8055 44.6259 18.2542C42.3659 17.328 39.8971 16.9717 33.6709 17.0017C25.5171 17.0405 22.4471 17.993 22.4471 17.993Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M43.1182 20.3142C41.7332 20.573 40.3382 20.7792 38.9382 20.9267C34.0332 21.443 29.0945 21.2467 24.2207 20.453C24.0682 20.428 23.9582 20.2855 23.9057 20.1205C23.717 19.8005 23.8445 19.2155 24.2895 19.193C25.6557 19.128 27.0232 19.0767 28.392 19.0392C33.2582 18.9054 38.127 18.9592 42.9907 19.1979C43.512 19.2229 43.682 20.2079 43.1195 20.3129L43.1182 20.3142Z'
        fill={spotIllustration.secondary.fill}
      />
    </Svg>
  )
}
